import { render, staticRenderFns } from "./appMeunSettings.vue?vue&type=template&id=68ddc55a&scoped=true"
import script from "./appMeunSettings.vue?vue&type=script&lang=js"
export * from "./appMeunSettings.vue?vue&type=script&lang=js"
import style0 from "./appMeunSettings.vue?vue&type=style&index=0&id=68ddc55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ddc55a",
  null
  
)

export default component.exports